module.exports = __webpack_public_path__ + "c_static/img/3-2京东-收藏宝贝.adb2fe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/3-2京东-收藏宝贝.jpg
// module id = SJ8b
// module chunks = 33